import { jsx } from "react/jsx-runtime";
import { flattenChildren } from "../../utils/flattenChildren.mjs";
import { useReducer } from "react";
import { RadioBarContext, RadioBarItemContext } from "./RadioBarContext.mjs";
import assert from "assert";
import { RadioBarItem } from "./RadioBarItem.mjs";
import { getNextEnabledIndex } from "../private/getNextIndex.mjs";
import { RADIOBAR_ITEM_FOCUSED, RADIOBAR_ITEM_CLICK, RADIOBAR_ITEM_SPACE, RADIOBAR_ITEM_TAB, RADIOBAR_ITEM_DOWN, RADIOBAR_ITEM_RIGHT, RADIOBAR_ITEM_UP, RADIOBAR_ITEM_LEFT } from "./RadioBar.actions.mjs";
import "../ThemeProvider/ThemeProvider.mjs";
import "../ThemePortal/ThemePortal.mjs";
import "../Text/TextContext.mjs";
import "../ThemeProvider/ThemeContext.mjs";
import "../ThemeProvider/VanillaThemeContainer.mjs";
import "../private/DefaultMessagesContext.mjs";
import "../ThemeProvider/BreakpointContext.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import { Box } from "../Box/Box.mjs";
import "../Box/BackgroundContext.mjs";
import "../Divider/Divider.css.mjs";
import "../Heading/HeadingContext.mjs";
import "../Hidden/Hidden.css.mjs";
import "../../css/negativeMargin/negativeMargin.css.mjs";
import "../Accordion/AccordionContext.mjs";
import "../private/defaultTextProps.mjs";
import "../../css/typography.css.mjs";
import "../private/MaxLines/MaxLines.css.mjs";
import { Columns } from "../Columns/Columns.mjs";
import { Column } from "../Column/Column.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../private/touchable/virtualTouchable.css.mjs";
import "../private/hideFocusRings/hideFocusRings.css.mjs";
import "../Accordion/AccordionItem.css.mjs";
import "../Actions/ActionsContext.mjs";
import "../../css/textAlignedToIcon.css.mjs";
import "../Alert/Alert.css.mjs";
import "../Autosuggest/Autosuggest.mjs";
import "../Avatar/Avatar.css.mjs";
import "../Badge/Badge.mjs";
import "../Breadcrumb/Breadcrumb.css.mjs";
import "../Box/ColoredBox.mjs";
import "../Button/Button.mjs";
import "../ButtonIcon/ButtonIcon.mjs";
import "../ButtonLink/ButtonLink.mjs";
import "../private/Keyline/Keyline.css.mjs";
import "../Checkbox/Checkbox.mjs";
import "../Checkbox/CheckboxStandalone.mjs";
import "../ContentBlock/ContentBlock.css.mjs";
import "../DateField/DateField.mjs";
import "../private/Field/FloatingLabel.css.mjs";
import "../private/Field/Field.css.mjs";
import "../DateField/DateField.css.mjs";
import "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import "../private/Modal/ModalContext.mjs";
import "../TextLink/TextLink.mjs";
import "../TextLinkButton/TextLinkButton.css.mjs";
import "../private/AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../Dropdown/Dropdown.mjs";
import "../HiddenVisually/HiddenVisually.css.mjs";
import "../Link/Link.mjs";
import "../List/List.css.mjs";
import "../Loader/Loader.css.mjs";
import "../Skeleton/Skeleton.css.mjs";
import "../MenuRenderer/MenuRenderer.mjs";
import "../MenuItem/MenuItem.mjs";
import "../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../MenuItemDivider/MenuItemDivider.mjs";
import "../MenuItem/MenuItemLink.mjs";
import "../OverflowMenu/OverflowMenu.css.mjs";
import "../MonthPicker/MonthPicker.mjs";
import "../Pagination/Pagination.css.mjs";
import "../PasswordField/PasswordField.mjs";
import "../Pincode/Pincode.mjs";
import "../PopoverRenderer/PopoverRenderer.mjs";
import "../Pressable/Pressable.mjs";
import "../RadioGroup/RadioGroup.mjs";
import "../RadioGroup/RadioItem.mjs";
import "../RadioGroup/RadioItemBlock.mjs";
import "../SelectableList/SelectableList.css.mjs";
import "../private/BulkActions/BulkActions.css.mjs";
import "../Spread/Spread.css.mjs";
import "../Stepper/Step.mjs";
import "../Stepper/Stepper.mjs";
import "../Tabs/Tab.mjs";
import "../Table/Table.mjs";
import "../Table/Table.css.mjs";
import "../Tabs/TabsProvider.mjs";
import "../Tabs/TabListContext.mjs";
import "../Tabs/Tabs.css.mjs";
import "../Tabs/TabPanelsContext.mjs";
import "../Tag/Tag.css.mjs";
import "../Textarea/Textarea.mjs";
import "../TextDropdown/TextDropdown.css.mjs";
import "../TextField/TextField.mjs";
import "../Tiles/Tiles.css.mjs";
import "../Toggle/Toggle.mjs";
import "../useToast/ToastContext.mjs";
import "../TooltipRenderer/TooltipRenderer.mjs";
import "../TimeField/DateSegment.css.mjs";
import "../private/FieldButtonIcon/FieldButtonIcon.mjs";
import "../MultiStepModal/MultiStepModal.mjs";
import "../SearchField/SearchField.mjs";
import { FieldGroup } from "../private/FieldGroup/FieldGroup.mjs";
const initialState = {
  selectedItemIndex: null,
  focusedItemIndex: null
};
const RadioBar = ({
  id,
  name,
  value,
  size = "standard",
  onChange,
  disabled,
  tone,
  children,
  ...props
}) => {
  const items = flattenChildren(children);
  const itemsCount = items.length;
  assert(
    items.every((item) => typeof item === "object" && "type" in item && item.type === RadioBarItem),
    "All child nodes within a RadioBar must be a RadioBarItem"
  );
  const [{ selectedItemIndex, focusedItemIndex }, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case RADIOBAR_ITEM_LEFT:
        case RADIOBAR_ITEM_UP: {
          return {
            ...state,
            focusedItemIndex: getNextEnabledIndex(-1, state.focusedItemIndex, itemsCount, items),
            selectedItemIndex: getNextEnabledIndex(-1, state.selectedItemIndex, itemsCount, items)
          };
        }
        case RADIOBAR_ITEM_RIGHT:
        case RADIOBAR_ITEM_DOWN: {
          return {
            ...state,
            focusedItemIndex: getNextEnabledIndex(1, state.focusedItemIndex, itemsCount, items),
            selectedItemIndex: getNextEnabledIndex(1, state.selectedItemIndex, itemsCount, items)
          };
        }
        case RADIOBAR_ITEM_TAB: {
          return {
            ...state,
            focusedItemIndex: null
          };
        }
        case RADIOBAR_ITEM_SPACE:
        case RADIOBAR_ITEM_CLICK:
        case RADIOBAR_ITEM_FOCUSED: {
          return {
            ...state,
            focusedItemIndex: action.value,
            selectedItemIndex: action.value
          };
        }
        default:
          return state;
      }
    },
    initialState
  );
  return /* @__PURE__ */ jsx(FieldGroup, { id, ...props, disabled, tone, space: "small", role: "radiogroup", children: (fieldGroupProps) => /* @__PURE__ */ jsx(Box, { borderRadius: "standard", children: /* @__PURE__ */ jsx(
    RadioBarContext.Provider,
    {
      value: {
        id,
        name: name || id,
        value,
        onChange,
        dispatch,
        itemsCount,
        tone,
        size,
        selectedItemIndex,
        focusedItemIndex,
        ...fieldGroupProps
      },
      children: /* @__PURE__ */ jsx(Columns, { collapseBelow: "tablet", space: "none", children: items.map((item, index) => /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(RadioBarItemContext.Provider, { value: { radioBarItemIndex: index }, children: item }) }, index)) })
    }
  ) }) });
};
RadioBar.displayName = "RadioBar";
export {
  RadioBar
};
